<template>
  <v-row class="my-1">
    <v-col class="py-0 break-container">
      <span class="break-text">{{ $t("commons.break") }}</span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Break",
  props: {
    formDisabled: { type: Boolean },
    label: { type: String, default: "" },
    typename: { type: String },
    values: {
      type: Array,
      default: () => {
        return [{ value: "" }]
      }
    }
  },
  computed: {
    lgLabel() {
      return `${this.label} - ${this.typename}`.toUpperCase()
    },
    pValue: {
      get() {
        return this.values[0].value
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    handleUpdate(updateObj) {
      const oldObj = { id: 0, value: this.value }
      const newValue = [{ ...oldObj, ...updateObj }]
      this.$emit("input", newValue)
    }
  }
}
</script>
<style scope>
.break-container {
  position: relative;
  text-align: center;
  margin: 20px 0;
}

.break-container::before,
.break-container::after {
  content: "";
  display: block;
  border-top: 1px solid #000;
  width: 40%;
  position: absolute;
  top: 50%;
}

.break-container::before {
  left: 0;
}

.break-container::after {
  right: 0;
}

.break-text {
  display: inline-block;
  padding: 0 10px;
  background-color: #fff;
  position: relative;
  z-index: 1;
}
</style>
